import { t, type I18nLocale } from '@ardoq/i18n';

type GetScenarioLabelArgs = {
  scenarioName: string | undefined;
  i18nLocale: I18nLocale;
};

export const getScenarioLabel = ({
  scenarioName,
  i18nLocale,
}: GetScenarioLabelArgs): string | null => {
  if (!scenarioName) return null;
  return t(
    i18nLocale,
    'presentationAdmin:viewer.topBar.scenarioLabel',
    { name: scenarioName },
    'Scenario: {{name}}'
  );
};
